import {
  FlexibleConnectedPositionStrategy,
  HorizontalConnectionPos,
  Overlay,
  OverlayRef,
  VerticalConnectionPos,
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { HorizontalPosition } from '@tekman/onmat/constants';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DropdownMenuService {
  public subjectOverlay = new BehaviorSubject<boolean>(false);
  public overlay$ = this.subjectOverlay.asObservable();
  constructor(public overlay: Overlay) {}

  getPosition(
    x: number,
    y: number,
    horizontalPosition: HorizontalPosition,
    verticalPosition: VerticalConnectionPos
  ): FlexibleConnectedPositionStrategy {
    return this.overlay
      .position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: this.getHorizontalPosition(horizontalPosition),
          originY: verticalPosition,
          overlayX: this.getHorizontalPosition(horizontalPosition),
          overlayY: 'top',
        },
      ]);
  }

  getHorizontalPosition(horizontalPosition: HorizontalPosition): HorizontalConnectionPos {
    switch (horizontalPosition) {
      case 'left':
        return 'start';
      case 'right':
        return 'end';
      default:
        return 'center';
    }
  }

  createOverlayRef(positionStrategy: FlexibleConnectedPositionStrategy, overlay: Overlay): OverlayRef {
    return overlay.create({
      positionStrategy,
      scrollStrategy: overlay.scrollStrategies.close(),
      hasBackdrop: true,
      backdropClass: 'no-overlay',
    });
  }

  createPortal(dropdownMenu: TemplateRef<any>, viewContainerRef: ViewContainerRef): TemplatePortal {
    return new TemplatePortal(dropdownMenu, viewContainerRef);
  }
}
